import React, { useEffect, useState } from "react";
import { useRef } from "react";
import api from "../Authentication/authService";
import jsPDF from "jspdf";
import { CONFIG } from "../../config";
import Toast from "../../Toast/Toast";
import SuccessfulPaymentSkeleton from "../Skeleton/SucessPaymentSkeleton"

const SuccessfulPayment = () => {
  const [toast , setToast] = useState(null);
   const apiUrl = CONFIG.REACT_APP_API_BASE_URL;
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [isLoading, setIsloading] = useState(false);



  useEffect(() => {
 
      const urlParams = new URLSearchParams(window.location.search);
      const encryptedDataFromURL = urlParams.get("data");
  //  const token = urlParams.get("token");
    setIsloading(true);

    // if (token) {  
    //    Cookies.set("Token", token, {
    //    domain: window.__ENV__.COOKIE_DOMAIN || undefined,
    //    secure: window.__ENV__.COOKIE_SECURE,
    //    sameSite: window.__ENV__.COOKIE_SAMESITE,
    //    path: "/"
    //  });
    
      // window.history.replaceState({}, document.title, "/SuccessfulPayment");
    // }
    api
      .post(`${apiUrl}/Payment/Data`,{Data:encryptedDataFromURL})
      .then((response) => {
        if (response) {
          setTransactionDetails(response.data);
        } else {
          setToast({
            type: "error",
            message: "Something went wrong, please try again.",
          });
        }
      })
      .catch(() => {
        setToast({
          type: "error",
          message: "Failed to load transaction details.",
        });
      })
      .finally(() => {
        setIsloading(false);
      });

      // handleDownloadReceipt();
  }, []);

  const iconRef = useRef(null);
  const titleRef = useRef(null);
  const descRef = useRef(null);
  const emailRef = useRef(null);
  const homeRef = useRef(null);
  const getCurrentDate = () => {
    const today = new Date();
    return `${String(today.getMonth() + 1).padStart(2, "0")}/
            ${String(today.getDate()).padStart(2, "0")}/
            ${today.getFullYear()}`;
  };
  useEffect(() => {
    setTimeout(() => {
      if (iconRef.current) {
        iconRef.current.style.opacity = 1;
        iconRef.current.style.transform = "rotate3d(1, 1, 1, 0deg)";
      }
    }, 1200);

    setTimeout(() => {
      if (titleRef.current) {
        titleRef.current.style.opacity = 1;
        titleRef.current.style.transform = "translateY(0)";
      }
    }, 1200);

    setTimeout(() => {
      if (descRef.current) {
        descRef.current.style.opacity = 1;
        descRef.current.style.transform = "translateY(0)";
      }
    }, 1200);

    setTimeout(() => {
      if (homeRef.current) {
        homeRef.current.style.opacity = 1;
        homeRef.current.style.transform = "translateY(0)";
      }
    }, 2100);

    setTimeout(() => {
      if (emailRef.current) {
        emailRef.current.style.opacity = 1;
      }
    }, 1200);
  }, []);

  const safeText = (value) => {
    return value !== undefined && value !== null ? String(value) : "";
  };

  const generateSimpleInvoice = (invoice) => {
    const doc = new jsPDF();

    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 15;

    /* ---------- LOGO ---------- */
    const logoBase64 =
      "data:image/png;base64,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"; // valid base64 required

    doc.addImage(logoBase64, "PNG", margin, 10, 50, 14);

    /* ---------- ADDRESS & PHONE ---------- */
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    doc.text(safeText(invoice.address), pageWidth - margin, 15, {
      align: "right",
    });
    doc.text(safeText(invoice.phone), pageWidth - margin, 21, {
      align: "right",
    });

    /* ---------- DIVIDER ---------- */
    doc.setLineWidth(0.6);
    doc.line(margin, 30, pageWidth - margin, 30);

    /* ---------- CLIENT / DATE ---------- */
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");

    doc.text(safeText(invoice.clientName), margin, 38);
    doc.text(safeText(invoice.dateTime), pageWidth - margin, 38, {
      align: "right",
    });

    doc.line(margin, 42, pageWidth - margin, 42);

    /* ---------- TRANSACTION DETAILS ---------- */
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    let startY = 50;
    const lineGap = 7;

    const details = [
      ["Credence Account Number:", invoice.credenceaccountMasked],
      ["Invoice Number:", invoice.invoiceNumber],
      ["Transaction ID:", invoice.transactionId],
      ["Auth Code:", invoice.authorizationCode],
    ];

    details.forEach(([label, value], index) => {
      doc.text(label, margin, startY + index * lineGap);
      doc.text(safeText(value), margin + 60, startY + index * lineGap);
    });

    /* ---------- PAYMENT DETAILS ---------- */
    startY += details.length * lineGap + 8;

    const paymentDetails =
      invoice.paymentType === "ACH"
        ? [
            ["Payment Type:", "ACH" + " - "+invoice.transactionType],
            ["Account Number:", invoice.accountMasked],
          ]
        : [
            ["Payment Type:", "Card"+ " - " +invoice.transactionType],
            ["Card Holder:", invoice.cardHolder],
            ["Card Number:", invoice.cardMasked],
            ["Card Type:", invoice.cardType],
          ];

    paymentDetails.forEach(([label, value], index) => {
      doc.text(label, margin, startY + index * lineGap);
      doc.text(safeText(value), margin + 60, startY + index * lineGap);
    });

    const dividerY = startY + paymentDetails.length * lineGap + 5;
    doc.line(margin, dividerY, pageWidth - margin, dividerY);

    /* ---------- AMOUNT ---------- */
    doc.setFont("helvetica", "bold");
    doc.text("Amount:", margin, dividerY + 10);
    doc.text(safeText(invoice.amount), pageWidth - margin, dividerY + 10, {
      align: "right",
    });

    /* ---------- BOTTOM LINE ---------- */
    doc.line(margin, dividerY + 15, pageWidth - margin, dividerY + 15);

    /* ---------- NOTE ---------- */
    doc.setFontSize(9);
    doc.setFont("helvetica", "italic");

    const noteText = doc.splitTextToSize(
      "Note: The payment in this receipt is subject to that payment successfully clearing.",
      pageWidth - margin * 2,
    );

    doc.text(noteText, margin, dividerY + 30);

    return doc;
  };

  // function formatDate(dateTimeString) {
  //   if (!dateTimeString) return "N/A";

  //   const [datePart, timePart] = dateTimeString.split(" ");
  //   if (!datePart || !timePart) return "Invalid date";

  //   const [day, month, year] = datePart.split("/");
  //   const [hours, minutes, seconds] = timePart.split(":");

  //   const date = new Date(
  //     Number(year),
  //     Number(month) - 1,
  //     Number(day),
  //     Number(hours),
  //     Number(minutes),
  //     Number(seconds),
  //   );

  //   if (isNaN(date.getTime())) return "Invalid date";

  //   const mm = String(date.getMonth() + 1).padStart(2, "0");
  //   const dd = String(date.getDate()).padStart(2, "0");
  //   const yyyy = date.getFullYear();

  //   const hh = String(date.getHours()).padStart(2, "0");
  //   const min = String(date.getMinutes()).padStart(2, "0");
  //   const ss = String(date.getSeconds()).padStart(2, "0");

  //   return `${mm}/${dd}/${yyyy} ${hh}:${min}:${ss}`;
  // }
function formatDate(dateTimeString) {
  if (!dateTimeString) return "N/A";

  const [datePart, timePart] = dateTimeString.split(" ");

  const [day, month, year] = datePart.split("/");
  const [hours, minutes, seconds] = timePart.split(":");

  const date = new Date(Date.UTC(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hours),
    Number(minutes),
    Number(seconds)
  ));

  if (isNaN(date.getTime())) return "Invalid date";


  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}
  const handleDownloadReceipt = (invoiceNumber) => {
    const fetchData = async () => {
      try {
        const res = await api.get(
          `${apiUrl}/PaymentHistory/receipt/${invoiceNumber}`
        );
  // console.log(res)
        const payment = Array.isArray(res.data) ? res.data[0] : res.data;
  
        const maskLast4 = (num) => `**** **** ${num?.slice(-4) || ""}`;
  
        const invoiceData = {
          clientName: payment.merchant,
          invoiceNumber: payment.invoiceNumber,
          transactionId: payment.uniqueID,
          paymentType: payment.paymentMode === "C" ? "Card" : "ACH",
          cardHolder: payment.cardHolder,
          cardMasked: maskLast4(payment.acccountNumber),
          accountMasked: maskLast4(payment.acccountNumber),
          amount: `$${Number(payment.amount || 0).toFixed(2)}`,
          dateTime: formatDate(payment.paymentDate),
          credenceaccountMasked: payment.credenceAccountNumber
            ? payment.credenceAccountNumber.substring(0, 2) +
              "****" +
              payment.credenceAccountNumber.slice(-3)
            : "",
          address: "1111 Digital Drive, Suite 101, Richardson TX 75081",
          phone: "+1 855 880 4791",
          authorizationCode: payment.authCode,
          cardType: payment.cardType,
          transactionType: payment.transType,
        };
  
        const pdf = generateSimpleInvoice(invoiceData);
        pdf.save(`Invoice_${payment.uniqueID}.pdf`);
      } catch (err) {
        setToast({
          type: "error",
          message: "Something went wrong while downloading the receipt.",
        });
      }
    };
  
    fetchData();
  };
  // if (isLoading || transactionDetails === null) {
  //   return (
  //     <div className="loading-wrapper">
  //       <ClipLoader color="#1c6ce5" size={60} />
  //     </div>
  //   );
  // }

  return (
    // <div className="app-shell-with-header">
    <>
    {toast && (
  <Toast
    message={toast.message}
    type={toast.type}
    onClose={() => setToast(null)}
  />
)}
<main className="main-content">
{isLoading || transactionDetails === null ? (
        <SuccessfulPaymentSkeleton />
      ) : 
      transactionDetails?.SFB === true ? (
        
          <div className="layout-container">
            <div className="layout-page">
              <section className="status-page-section">
                {transactionDetails?.DigiWallet ? (
                  <>
                    <section className="status-page-section">
                      <div className="status-page-container">
                        <div className="status-hero">
                          <div className="status-icon-wrapper failed-icon-wrapper">
                            <div className="status-icon-circle">
                              <i className="bx bx-x"></i>
                            </div>
                            <div className="status-icon-pulse"></div>
                          </div>

                          <h1 className="status-title failed-title">
                            Plan Creation Failed
                          </h1>

                          <p className="status-subtitle text-balance">
                            Scheduled payments aren’t supported with Apple Pay
                            or Google Pay, so your payment plan will be
                            cancelled automatically.
                          </p>
                        </div>

                        <div className="status-navigation">
                          <a href="/Payment" className="btn-primary">
                            Try Again
                          </a>
                        </div>
                      </div>
                    </section>
                  </>
                ) : (
                  <div className="status-page-container">
                    <div className="status-hero">
                      <div className="status-icon-wrapper plan-icon-wrapper">
                        <div className="status-icon-circle">
                          <i className="bx bx-calendar-check"></i>
                        </div>
                        <div className="status-icon-pulse"></div>
                      </div>

                      <h1 className="status-title plan-title">
                        Payment Plan Created!
                      </h1>
                      <p className="status-subtitle">
                        Your payment schedule has been successfully set up
                      </p>

                      
                    </div>

                    <div className="status-navigation">
                      <a href="/PaymentPlan" className="btn-primary">
                        View My Plans
                      </a>
                    </div>
                  </div>
                )}
              </section>
            </div>
          </div>

        
      ) : (
        
          <div className="layout-container">
            <div className="layout-page">
              <section className="status-page-section">
                <div className="status-page-container">
                  <div className="status-hero">
                    <div className="status-icon-wrapper success-icon-wrapper">
                      <div className="status-icon-circle">
                        <i className="bx bx-check"></i>
                      </div>
                      <div className="status-icon-pulse"></div>
                    </div>

                    <h1 className="status-title success-title">
                      Payment Successful!
                    </h1>
                    <p className="status-subtitle">
                      Your payment has been processed successfully
                    </p>

                    <div className="status-reference">
                      <span className="reference-label">Invoice Number</span>
                      <span className="reference-value">
                        {transactionDetails?.EncryptedInvoiceNumber || "NA"}
                      </span>
                    </div>
                  </div>

                  <div className="general-card status-summary-card">
                    <div className="status-summary-header">
                      <h3 className="summary-section-title">Payment Summary</h3>
                      <span className="summary-date">
                        <i className="bx bx-calendar"></i>
                        {getCurrentDate()}
                      </span>
                    </div>

                    <div className="status-summary-body">
                      <div className="summary-row summary-row-highlight">
                        <span className="summary-label mb-0">Amount Paid</span>
                        <span className="summary-value amount-paid">
                       {transactionDetails?.EncryptedSALEAMOUNT
  ? `$ ${parseFloat(transactionDetails.EncryptedSALEAMOUNT).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`
  : "NA"}
                        </span>
                      </div>
                      <div className="summary-row">
                        <span className="summary-label mb-0">
                          Transaction ID
                        </span>
                        <span className="summary-value transaction-id">
                          {transactionDetails?.EncryptedPaymentID || "NA"}
                        </span>
                      </div>
                      <div className="summary-row">
                        <span className="summary-label mb-0">
                          Payment Method
                        </span>
                        <span className="summary-value">
                          {transactionDetails?.EncryptedCcType || "NA"}{" "}
                        </span>
                      </div>

                      <div className="summary-row">
                        <p className="xxsmall">
                          Note: The payment in this receipt is subject to that
                          payment successfully clearing.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="status-actions">
                    <button
                      className="btn-status-action btn-download"
                      onClick={() =>
                        handleDownloadReceipt(
                          transactionDetails?.EncryptedInvoiceNumber,
                        )
                      }
                    >
                      <i className="bx bx-download"></i>
                      <span>Download Receipt</span>
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>

          
      )}
      <button id="helpPopup-button" className="helpPopupButton">
            <i className="bx bx-help-circle"></i>
          </button>
        </main>
      </>
    // </div>
  );
};

export default SuccessfulPayment;
